const MenuHorizontal = () => {
    const pathActual = window.location.pathname;

    const menuItems = [
        { name: 'Inicio', url: '/' },
        { name: 'Fuentes', url: '/sources' },
        { name: 'Perfiles', url: '/profiles' }
        // Puedes agregar más elementos según sea necesario
    ];

    return (
        <header className="mb-3">
            <nav>
                <ul>
                    {menuItems.map((item) => (
                        <li key={item.name} className={pathActual === item.url ? 'active' : ''}>
                            <a href={item.url}>{item.name}</a>
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    );
}

export default MenuHorizontal;